﻿export class booking_note {
    public type: string | null = null;
    public note: string | null = null;
    public internal_data: boolean | null = null;
}